import React, { useState } from "react";
import "./App.css";
import Modal from "./components/Modal";
import ModalSequence from "./components/modal-page/ModalSequence";

const App = () => {
    // State management
    const [modalOpen, setModalOpen] = useState(false);
    const {
        wishlist_name: wishlistName,
        isbn_name_singular: isbnNameSingular,
        isbn_name_plural: isbnNamePlural,
        max_isbns: maxIsbns,
    } = window.prhReact;

    // Functions
    const launchModal = () => {
        setModalOpen(true);
    };

    const resetModal = () => {
        setModalOpen(false);
    };

    // Display
    return (
        <React.Fragment>
            <button
                id="copy-paste-isbn-button"
                className="btn"
                onClick={() => launchModal()}
            >
                <i class="fa fa-plus" aria-hidden="true"></i>
                <span class="button-text">Add {isbnNamePlural}</span>
            </button>
            <Modal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
                modalTitle={`Add to ${wishlistName}`}
            >
                <ModalSequence
                    resetModal={resetModal}
                    wishlistName={wishlistName}
                    isbnNameSingular={isbnNameSingular}
                    isbnNamePlural={isbnNamePlural}
                    maxIsbns={maxIsbns}
                />
            </Modal>
        </React.Fragment>
    );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js